import { useEffect } from 'react';

const useDocumentZoom = () => {
	useEffect(() => {
		function applyDocumentZoom() {
			const initialHeight = 1080;
			const precision = 1000;
			const zoomAmount =
				Math.round((window.innerHeight / initialHeight) * precision) /
				precision;

			document.body.style.scale = zoomAmount.toFixed(4);
			document.body.style.width = `calc(${1 / zoomAmount} * 100%)`;
			document.body.style.height = `calc(${1 / zoomAmount} * 100%)`;
			document.body.style.setProperty('--zoom-factor', zoomAmount.toString());
		}

		window.addEventListener('resize', applyDocumentZoom);
		applyDocumentZoom();

		// Cleanup event listener on unmount
		return () => {
			window.removeEventListener('resize', applyDocumentZoom);
		};
	}, []);
};

export { useDocumentZoom };
